export enum ChatState {
	ON = 'on',
	OFF = 'off',
	// INVISIBLE = 'invisible', // DEPRECATED
	AGENT_QUEUE = 'agentqueue',
}
export type IChatStateConfiguration = { state: ChatState };
